import { Sprite } from "@pixi/sprite";
import { Texture } from "@pixi/core";

export class InputBlocker extends Sprite {
    public get blocked(): boolean {
        return this.interactive;
    }

    public set blocked(value: boolean) {
        this.eventMode = value === true ? "dynamic" : "none";
    }

    public constructor() {
        super(Texture.WHITE);
        this.alpha = 0;
        this.blocked = true;
    }
}
